<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'mypage::event::cart', params: {} }">
          <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[8][1]"/></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <p class="text-center mb-0"><trans-text i18nKey="ui[8][2]"/></p>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">
          <!--<div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">-->
          <!--<b><trans-text :i18nKey="apiErrorI18nKey"/></b>-->
          <!--</div>-->
          <!-- 入力フォーム -->

          <page-form :orderer="orderer" :childInfos="childInfos" :cartEvents="cartEvents" :familyRelations="familyRelations" :storeData="storeData" ></page-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/Order/Form/PageForm.vue'

  export default {
    name:"",
    components: {
      PageForm,
    },
    data () {
      return {
        storeData:{},
        familyRelations:{},
        childInfos:{},
        orderer:{},
        cartEvents:{},
      }
    },
    computed:{
    },
    mounted(){

      Promise.all([
        app.make("axios").get(`v1/util/family-relation`,{}),
        app.make("axios").get(`v1/account/child-info`,{}),
        app.make("axios").get(`v1/account/orderer/index`,{}),
        app.make("axios").get(`v1/cart-event`,{
          params: {
            is_purchase_target:1
          }
        }),
      ]).then( ([familyRelation, childInfo,Orderer,cartEvent]) => {
        this.familyRelations = familyRelation.data.data.family_relations
        this.childInfos = childInfo.data.data.child_info
        this.orderer = Orderer.data.data.orderer
        this.cartEvents = cartEvent.data
        let pageData = store.session("order_form")
        //dd("AA",pageData)

        if(pageData){
          this.$nextTick(function () {
            this.storeData = pageData
          });
          //return Promise.reject("store");
        }else{
          //TODO ユーザー名のアップデート
          app.make("axios").get(`v1/current-order`,{})
            .then((res)=> {
              let orderer = res.data.order_orderers[0]
              let buyerUser = res.data.buyer_user
              let input = {
                family_name: orderer.family_name,
                given_name: orderer.given_name,
                address_1: orderer.address_1,
                address_2: orderer.address_2,
                city: orderer.city,
                prefecture: orderer.prefecture,
                zip_code: orderer.zip_code,
                country_name: orderer.country_name,
                phone_nunber: orderer.phone_nunber,
                email: buyerUser.email,
              }

              let orderEvents = res.data.order_events
              let child_info_input = []
              for (let orderEvent of orderEvents) {
                child_info_input.push({
                  event_name: orderEvent.event.name,
                  event_id: orderEvent.event.id,
                  school_name: orderEvent.event.id,
                  child_info_id: orderEvent.order_event_participants[0].original_participant_id,
                  family_name: orderEvent.order_event_participants[0].family_name,
                  given_name: orderEvent.order_event_participants[0].given_name,
                  group_name: orderEvent.order_event_participants[0].group_name,
                  family_relation_id: orderEvent.order_event_participants[0].family_relation_id,
                })
              }
              store.session({order_form: {input, child_info_input}})
              let pageData = store.session("order_form")
              this.storeData = pageData
            })
        }
      })
    },
    methods:{
    }
  }
</script>


<style lang="scss" scoped>
  .questionnaire-subhead{
    padding:.1rem 1rem;
    font-size: 1.2rem;
    border: 1px solid #000;
    background-color: #ffffc1;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?3108af6b